import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50">
      <Navbar />
      
      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-indigo-100 border border-indigo-200 mb-6">
              <span className="w-2 h-2 bg-indigo-600 rounded-full mr-2 animate-pulse"></span>
              <span className="text-sm font-medium text-indigo-700 uppercase tracking-wider">
                Legal
              </span>
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Cookie Policy</h1>
            <p className="text-gray-600">Last updated: January 1, 2024</p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. What Are Cookies</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Cookies are small text files that are placed on your computer or mobile device when you visit a website. 
                  They are widely used to make websites work more efficiently and provide information to the owners of the site.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  AdBlastX uses cookies to improve your experience on our website, analyze site traffic, and understand where 
                  our visitors are coming from.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Types of Cookies We Use</h2>
                
                <div className="space-y-6">
                  <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">Essential Cookies</h3>
                    <p className="text-gray-600 leading-relaxed">
                      These cookies are necessary for the website to function properly. They enable basic functions like 
                      page navigation and access to secure areas of the website. The website cannot function properly 
                      without these cookies.
                    </p>
                  </div>

                  <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">Analytics Cookies</h3>
                    <p className="text-gray-600 leading-relaxed">
                      These cookies help us understand how visitors interact with our website by collecting and reporting 
                      information anonymously. We use this information to improve our website and services.
                    </p>
                    <p className="text-gray-600 mt-2">
                      <strong>Examples:</strong> Google Analytics, Hotjar
                    </p>
                  </div>

                  <div className="bg-purple-50 rounded-xl p-6 border border-purple-200">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">Marketing Cookies</h3>
                    <p className="text-gray-600 leading-relaxed">
                      These cookies are used to track visitors across websites. The intention is to display ads that are 
                      relevant and engaging for the individual user and thereby more valuable for publishers and third-party 
                      advertisers.
                    </p>
                    <p className="text-gray-600 mt-2">
                      <strong>Examples:</strong> Facebook Pixel, Google Ads, LinkedIn Insight Tag
                    </p>
                  </div>

                  <div className="bg-orange-50 rounded-xl p-6 border border-orange-200">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">Preference Cookies</h3>
                    <p className="text-gray-600 leading-relaxed">
                      These cookies enable the website to remember information that changes the way the website behaves or 
                      looks, like your preferred language or the region that you are in.
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. How We Use Cookies</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We use cookies for the following purposes:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li><strong>Authentication:</strong> To identify you when you visit our website and as you navigate our website</li>
                  <li><strong>Status:</strong> To help us determine if you are logged into our website</li>
                  <li><strong>Personalization:</strong> To store information about your preferences and to personalize the website for you</li>
                  <li><strong>Security:</strong> As an element of the security measures used to protect user accounts</li>
                  <li><strong>Analysis:</strong> To help us analyze the use and performance of our website and services</li>
                  <li><strong>Advertising:</strong> To help us display advertisements that will be relevant to you</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Third-Party Cookies</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  In addition to our own cookies, we may also use various third-party cookies to report usage statistics 
                  of the website and deliver advertisements on and through the website.
                </p>
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-200 mt-4">
                  <h4 className="font-bold text-gray-900 mb-3">Third-Party Services We Use:</h4>
                  <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                    <li>Google Analytics - Website analytics</li>
                    <li>Google Ads - Advertising and remarketing</li>
                    <li>Facebook Pixel - Advertising and analytics</li>
                    <li>LinkedIn Insight Tag - Analytics and advertising</li>
                    <li>Hotjar - User behavior analytics</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Managing Cookies</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences 
                  by clicking on the appropriate opt-out links provided in the cookie banner or by setting your browser to 
                  refuse cookies.
                </p>
                
                <div className="bg-indigo-50 rounded-xl p-6 border border-indigo-200 mt-4">
                  <h4 className="font-bold text-gray-900 mb-3">Browser Settings:</h4>
                  <p className="text-gray-600 mb-3">
                    Most web browsers allow you to control cookies through their settings preferences. However, if you limit 
                    the ability of websites to set cookies, you may worsen your overall user experience.
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                    <li><strong>Chrome:</strong> Settings → Privacy and security → Cookies and other site data</li>
                    <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies and Site Data</li>
                    <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
                    <li><strong>Edge:</strong> Settings → Cookies and site permissions → Cookies and site data</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Cookie Duration</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Cookies can be either "session" cookies or "persistent" cookies:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li><strong>Session Cookies:</strong> These are temporary cookies that expire when you close your browser</li>
                  <li><strong>Persistent Cookies:</strong> These remain on your device for a set period or until you delete them</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Do Not Track Signals</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Some browsers have a "Do Not Track" feature that lets you tell websites that you do not want to have your 
                  online activities tracked. At this time, we do not respond to browser "Do Not Track" signals.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Updates to This Policy</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We may update this Cookie Policy from time to time to reflect changes in our practices or for other 
                  operational, legal, or regulatory reasons. We encourage you to review this policy periodically.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. More Information</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  For more information about cookies and how to manage them, visit:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li><a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-700">AllAboutCookies.org</a></li>
                  <li><a href="https://www.youronlinechoices.com" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-700">YourOnlineChoices.com</a></li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contact Us</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  If you have any questions about our use of cookies, please contact us:
                </p>
                <div className="bg-indigo-50 rounded-xl p-6 border border-indigo-200">
                  <p className="text-gray-700 font-semibold mb-2">Email:</p>
                  <a href="mailto:contact@AdBlastX.com" className="text-indigo-600 hover:text-indigo-700 font-semibold">
                    contact@AdBlastX.com
                  </a>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CookiePolicyPage;
